// Normalizers for input values.

export const asInteger = (value) => parseInt(value, 10);
export const asFloat = (value) => parseFloat(value, 10);

const MAX_DEGREES = 360;
// Returns a value in degrees in the range [0, 360)
export const asRotationDegrees = (rotation) =>
  parseFloat(
    (
      ((parseFloat(rotation, 10) % MAX_DEGREES) + MAX_DEGREES) %
      MAX_DEGREES
    ).toFixed(1),
    10,
  );
